import { BASE_URI, OPEN_URI } from "./index";
import {exportPager} from "@/api/examStatistics";

//注：apiURL设置，这里的设置与asyncRouterMap中的名称需要保持一致，如这里配置的user(adminResource=true)与asyncRouterMap中的user相对应决定权限
export const apiConfig = {
  auth: {
    resource: false,
    api: {
      login: BASE_URI + "/oauth/login",
      checkToken: BASE_URI + "/auth/checkToken",
      resource: BASE_URI + "/auth/resources",
      logout: BASE_URI + "/auth/logout",
      changePassword: BASE_URI + "/auth/changePassword",
      getExamUrl: BASE_URI + "/auth/getExamUrl",
      getOnlineUsers: BASE_URI + "/auth/getTotalOnlineUser",
      getOnlineUsersList: BASE_URI + "/auth/user/list",
      captcha: BASE_URI + "/oauth/captcha",
      getOauthCode: BASE_URI + '/oauth/code',
      loginByOauthCode: BASE_URI + '/oauth/loginByOauthCode',
      organizationRegister: BASE_URI + '/oauth/organizationRegister',
      getCooperationPlatform: BASE_URI + '/oauth/getCooperationPlatform',
    },
    meta: {
      name: "查询字典表，通用",
      url: BASE_URI + "/auth/getMetaDataList"
    }
  },
  other: {
    resource: false,
    api: {}
  },
  openApi: {
    resource: false,
    api: {
      resume: {
        name: "简历信息",
        url: OPEN_URI + "/queryResume"
      },
      queryCertificate: {
        name: "查询证书",
        url: OPEN_URI + "/queryCertificate"
      },
      dictionary: {
        name: "查询字典",
        url: OPEN_URI + "/dictionary/list/",
      }
    }
  },
  userInfo: {
    name: "用户个人信息",
    resource: true,
    api: {
      pager: {
        name: "用户信息分页列表",
        url: BASE_URI + "/userInfo/pager"
      },
      searchPager: {
        name: "用户信息分页列表搜索功能",
        url: BASE_URI + "/userInfo/searchPager"
      },
      find: {
        name: "查询用户信息",
        url: BASE_URI + "/userInfo/find"
      },
      add: {
        name: "新增用户信息",
        url: BASE_URI + "/userInfo/add"
      },
      update: {
        name: "更新用户信息",
        url: BASE_URI + "/userInfo/update"
      },
      importIdPhoto: {
        name: "导入证件照",
        url: {
          import: BASE_URI + "/userInfo/importIdPhoto",
          exportError: BASE_URI + "/userInfo/exportIdPhotoError"
        }
      },
      importTrainingFile: {
        name: "导入培训证明",
        url: {
          import: BASE_URI + "/userInfo/importResumeTrainingFile",
          exportError: BASE_URI + "/userInfo/exportResumeTrainingFileError",
        },
      },
      importUserInfo: {
        name: "导入用户信息",
        url: {
          import: BASE_URI + "/userAccount/importUserInfo",
          importSpecial: BASE_URI + "/userAccount/importUserInfoSpecial",
          exportError: BASE_URI + "/userAccount/exportUserInfoError"
        }
      },
      doImportUserInfo: {
        name: "导入用户信息",
        url: {
          import: BASE_URI + "/userAccount/doImportUserInfo",
          importSpecial: BASE_URI + "/userAccount/doImportUserInfoSpecial",
          exportError: BASE_URI + "/userAccount/exportUserInfoError"
        }
      },
      exportUserList: {
        name: "导出个人信息",
        url: BASE_URI + "/userInfo/export"
      },
      mergeAccount: {
        name: "合并账户",
        url: BASE_URI + "/userInfo/mergeAccount"
      },
      bindUserProject: {
        name: "绑定用户项目",
        url: BASE_URI + "/userInfo/bindUserProject"
      },
      downloadUserAccount: {
        name: "导出测评信息",
        url: BASE_URI + "/userInfo/downloadUserAccount"
      },
      getAgentChildAll: {
        name: "导出测评信息",
        url: BASE_URI + "/userInfo/getAgentChildAll"
      },
      viewExam: {
        name: "导出测评信息",
        url: BASE_URI + "/userInfo/viewExam"
      },
      batchAddTags: {
        name: "批量新增用户标签",
        url: BASE_URI + "/userInfo/batchAddTags",
      },
      getTagsLike: {
        name: "模糊搜索用户标签",
        url: BASE_URI + "/userInfo/getTagsLike",
      },
      getActivityStatistics: {
        name: "获取活动统计数据",
        url: BASE_URI + "/userInfo/getActivityStatistics",
      },
      getActivityStatisticsAll: {
        name: "获取活动所有统计数据",
        url: BASE_URI + "/userInfo/getActivityStatisticsAll",
      },
    }
  },
  userResumeInfo: {
    name: "用户简历基本信息",
    resource: false,
    api: {
      findResume: {
        name: "查询用户简历信息",
        url: BASE_URI + "/userResumeInfo/findResume"
      },
      update: {
        name: "更新用户简历信息",
        url: BASE_URI + "/userResumeInfo/saveResume"
      },
      getResumeCertificateList: {
        name: "获取荣誉证书列表",
        url: BASE_URI + "/userResumeInfo/getResumeCertificateList"
      },
      findResumeCertificate: {
        name: "获取荣誉证书",
        url: BASE_URI + "/userResumeInfo/findResumeCertificate"
      },
      addResumeCertificate: {
        name: "新增荣誉证书",
        url: BASE_URI + "/userResumeInfo/addResumeCertificate"
      },
      updateResumeCertificate: {
        name: "更新荣誉证书",
        url: BASE_URI + "/userResumeInfo/updateResumeCertificate"
      },
      deleteResumeCertificate: {
        name: "删除荣誉证书",
        url: BASE_URI + "/userResumeInfo/deleteResumeCertificate"
      },
      getResumeEducationList: {
        name: "获取教育经历列表",
        url: BASE_URI + "/userResumeInfo/getResumeEducationList"
      },
      findResumeEducation: {
        name: "获取教育经历证书",
        url: BASE_URI + "/userResumeInfo/findResumeEducation"
      },
      addResumeEducation: {
        name: "新增教育经历证书",
        url: BASE_URI + "/userResumeInfo/addResumeEducation"
      },
      updateResumeEducation: {
        name: "更新教育经历证书",
        url: BASE_URI + "/userResumeInfo/updateResumeEducation"
      },
      deleteResumeEducation: {
        name: "删除教育经历证书",
        url: BASE_URI + "/userResumeInfo/deleteResumeEducation"
      },
      getResumeInternshipList: {
        name: "获取实习经历列表",
        url: BASE_URI + "/userResumeInfo/getResumeInternshipList"
      },
      findResumeInternship: {
        name: "获取实习经历",
        url: BASE_URI + "/userResumeInfo/findResumeInternship"
      },
      addResumeInternship: {
        name: "新增实习经历",
        url: BASE_URI + "/userResumeInfo/addResumeInternship"
      },
      updateResumeInternship: {
        name: "更新实习经历",
        url: BASE_URI + "/userResumeInfo/updateResumeInternship"
      },
      deleteResumeInternship: {
        name: "删除实习经历",
        url: BASE_URI + "/userResumeInfo/deleteResumeInternship"
      },
      getResumeProjectList: {
        name: "获取项目经历列表",
        url: BASE_URI + "/userResumeInfo/getResumeProjectList"
      },
      findResumeProject: {
        name: "获取项目经历",
        url: BASE_URI + "/userResumeInfo/findResumeProject"
      },
      addResumeProject: {
        name: "新增项目经历",
        url: BASE_URI + "/userResumeInfo/addResumeProject"
      },
      updateResumeProject: {
        name: "更新项目经历",
        url: BASE_URI + "/userResumeInfo/updateResumeProject"
      },
      deleteResumeProject: {
        name: "删除项目经历",
        url: BASE_URI + "/userResumeInfo/deleteResumeProject"
      },
      getResumeTrainingList: {
        name: "获取培训经历列表",
        url: BASE_URI + "/userResumeInfo/getResumeTrainingList"
      },
      findResumeTraining: {
        name: "获取培训经历",
        url: BASE_URI + "/userResumeInfo/findResumeTraining"
      },
      addResumeTraining: {
        name: "新增培训经历",
        url: BASE_URI + "/userResumeInfo/addResumeTraining"
      },
      updateResumeTraining: {
        name: "更新培训经历",
        url: BASE_URI + "/userResumeInfo/updateResumeTraining"
      },
      deleteResumeTraining: {
        name: "删除培训经历",
        url: BASE_URI + "/userResumeInfo/deleteResumeTraining"
      },
      getResumeWorkList: {
        name: "获取工作经历列表",
        url: BASE_URI + "/userResumeInfo/getResumeWorkList"
      },
      findResumeWork: {
        name: "获取工作经历",
        url: BASE_URI + "/userResumeInfo/findResumeWork"
      },
      addResumeWork: {
        name: "新增工作经历",
        url: BASE_URI + "/userResumeInfo/addResumeWork"
      },
      updateResumeWork: {
        name: "更新工作经历",
        url: BASE_URI + "/userResumeInfo/updateResumeWork"
      },
      deleteResumeWork: {
        name: "删除工作经历",
        url: BASE_URI + "/userResumeInfo/deleteResumeWork"
      }
    }
  },
  agentInfo: {
    name: "机构列表",
    resource: true,
    api: {
      pager: {
        name: "机构分页列表",
        url: BASE_URI + "/agentInfo/pager"
      },
      searchPager: {
        name: "机构分页列表搜索功能",
        url: BASE_URI + "/agentInfo/searchPager"
      },
      find: {
        name: "查看机构基本信息",
        url: BASE_URI + "/agentInfo/find"
      },
      getAgentByName: {
        name: "根据机构名称模糊查询机构列表",
        url: BASE_URI + "/agentInfo/getAgentByNameLike"
      },
      edit: {
        name: "编辑机构基本信息",
        url: BASE_URI + "/agentInfo/edit"
      },
      getExamList: {
        name: "机构考场列表",
        url: BASE_URI + "/agentInfo/getExamList"
      },
      getExamUserPager: {
        name: "查看参与考场的用户",
        url: BASE_URI + "/agentInfo/getExamUserPager"
      },
      getSubAgentList: {
        name: "子机构列表",
        url: BASE_URI + "/agentInfo/getSubAgentList"
      },
      getSubAgentProjectList: {
        name: "子机构项目列表",
        url: BASE_URI + "/agentInfo/getSubAgentProjectList"
      },
      getSubAgentProjectUserPager: {
        name: "查看子机构项目的用户",
        url: BASE_URI + "/agentInfo/getSubAgentProjectUserPager"
      },
      suspend: {
        name: "暂停账号",
        url: BASE_URI + "/agentInfo/suspend"
      },
      delete: {
        name: "删除机构",
        url: BASE_URI + "/agentInfo/delete"
      },
      agentList: {
        name: "删除机构",
        url: BASE_URI + "/agentInfo/getAgentList"
      },
      agentTree: {
        name: "机构树",
        url: BASE_URI + "/agentInfo/getAgentTree"
      },
      agentTreePager: {
        name: "机构树分页",
        url: BASE_URI + "/agentInfo/getAgentTreePager"
      },
      getAgentRanking: {
        name: "查询直销机构排名",
        url: BASE_URI + "/agentInfo/getAgentRanking"
      },
      agentRegisterStatus: {
        name: "查询机构是否注册",
        url: BASE_URI + "/open/agentRegisterStatus"
      },
      agentRegister: {
        name: "机构注册",
        url: BASE_URI + "/open/agentRegister"
      },
      addShzzQuestionnaire: {
        name: "保存社会组织机构调研问卷",
        url: BASE_URI + "/open/addShzzQuestionnaire"
      }
    }
  },
  userAssess: {
    name: "用户测评信息",
    resource: true,
    api: {
      pager: {
        name: "用户测评信息分页列表",
        url: BASE_URI + "/userAssess/pager"
      },
      searchPager: {
        name: "用户测评信息分页列表搜索功能",
        url: BASE_URI + "/userAssess/searchPager"
      },
      getScaleList: {
        name: "查看测评详情",
        url: BASE_URI + "/userAssess/getScaleListByExamUserId"
      },
      viewReport: {
        name: "查看测评报告",
        url: BASE_URI + "/oauth/getUserReport"
      },
      viewExamReport: {
        name: "查看考场报告",
        url: BASE_URI + "/oauth/getUserExamReport",
      },
      downloadReport: {
        name: "下载测评报告",
        url: BASE_URI + "/oauth/downloadReport"
      },
      downloadReportBatch: {
        name: "批量下载测评报告",
        url: BASE_URI + "/userAssess/downloadReportBatch"
      },
      resetUserAccountPassword: {
        name: "重置用户密码",
        url: BASE_URI + "/userAssess/resetUserAccountPassword"
      },
      downloadReportZip: {
        name: "批量下载测评报告ZIP",
        url: BASE_URI + "/userAssess/downloadReportZip"
      },
      downloadScaleReportPdf: {
        name: "下载量表测评报告pdf",
        url: BASE_URI + "/userAssess/downloadScaleReportPdf"
      },
      downloadExamReportPdf: {
        name: "下载考场报告pdf",
        url: BASE_URI + "/userAssess/downloadExamReportPdf",
      },
      downloadReportZipUrl: {
        name: "点击连接下载测评报告ZIP",
        url: BASE_URI + "/userAssess/downloadReportZipUrl"
      },
      isOver: {
        name: "轮询生成证书zip是否完成",
        url: BASE_URI + "/userAssess/isOver"
      },
      downloadPageQuery: {
        name: '下载列表分页',
        url: BASE_URI + '/userAssess/download/page',
      },
      downloadReportZipUrlAsync: {
        name: "点击连接下载测评报告ZIP异步",
        url: (id) => `${BASE_URI}/userAssess/downloadReportZipUrlAsync/${id}`,
      },
      batchExportExamReportZipAsync: {
        name: '批量导出考场报告zip异步',
        url: BASE_URI + "/userAssess/batchExportExamReportZipAsync",
      },
      exportUserAssessInfo: {
        name: "导出用户测评信息",
        url: BASE_URI + "/userAssess/exportUserAssessInfo",
      },
    },
  },
  userCertificate: {
    name: "用户证书信息",
    resource: true,
    api: {
      pager: {
        name: "用户证书信息分页列表",
        url: BASE_URI + "/userCertificate/pager"
      },
      searchPager: {
        name: "用户证书信息分页列表搜索功能",
        url: BASE_URI + "/userCertificate/searchPager"
      },
      viewCertificateImg: {
        name: "查看证书",
        url: BASE_URI + "/userCertificate/viewCertificateImg"
      },
      getDigitalCertificateList: {
        name: "查看电子证书信息",
        url: BASE_URI + "/userCertificate/getDigitalCertificateList"
      },
      getPaperCertificateInfo: {
        name: "查看纸质证书信息",
        url: BASE_URI + "/userCertificate/getPaperCertificateInfo"
      },
      editPaperCertificateStatus: {
        name: "标记纸质证书购买状态",
        url: BASE_URI + "/userCertificate/editPaperCertificateStatus"
      },
      editPaperCertificateStatusBatch: {
        name: "批量标记纸质证书购买状态",
        url: BASE_URI + "/userCertificate/editPaperCertificateStatusBatch"
      },
      uploadPaperCertificateUser: {
        name: "上传购买纸质证书用户",
        url: BASE_URI + "/userCertificate/uploadPaperCertificateUser"
      },
      exportUserCertificate: {
        name: "导出入库信息",
        url: BASE_URI + "/userCertificate/export"
      },
      exportUserCertificateSelect: {
        name: "导出选中入库信息",
        url: BASE_URI + "/userCertificate/exportSelect"
      },
      exportZip: {
        name: "导出证书zip",
        url: BASE_URI + "/userCertificate/exportZip"
      },
      getCerCode: {
        name: "导出证书zip",
        url: BASE_URI + "/userCertificate/getCerCode"
      }
    }
  },
  projectInfo: {
    name: "项目列表",
    resource: true,
    api: {
      pager: {
        name: "项目分页列表",
        url: BASE_URI + "/projectInfo/pager"
      },
      searchPager: {
        name: "项目分页列表搜索功能",
        url: BASE_URI + "/projectInfo/searchPager"
      },
      projectList: {
        name: "项目列表",
        url: BASE_URI + "/projectInfo/list"
      },
      getProjectUser: {
        name: "查询项目用户",
        url: BASE_URI + "/projectInfo/getProjectUser"
      },
      getProjectsId: {
        name: "查询所有项目",
        url: BASE_URI + "/projectInfo/getProjectsId"
      },
      findProjectAgentPager: {
        name: "查询所有项目",
        url: BASE_URI + "/projectInfo/findProjectAgentPager"
      },
      searchProjectByAgentIds: {
        name: "查询所有项目",
        url: BASE_URI + "/projectInfo/searchProjectByAgentIds"
      }
    }
  },
  scaleInfo: {
    name: "量表列表",
    resource: true,
    api: {
      pager: {
        name: "量表分页列表",
        url: BASE_URI + "/scale/pager",
      },
      saveBaseInfoDraft: {
        name: "保存量表基础信息草稿",
        url: BASE_URI + "/scale/saveBaseInfoDraft",
      },
      saveSubjectDraft: {
        name: "保存量表题目信息草稿",
        url: BASE_URI + "/scale/saveSubjectDraft",
      },
      saveSubjectConfigDraft: {
        name: "保存量表试卷配置草稿",
        url: BASE_URI + "/scale/saveSubjectConfigDraft",
      },
      submitScale: {
        name: "提交量表草稿",
        url: BASE_URI + "/scale/submitScale",
      },
      scaleSubjectPager: {
        name: "获取量表题库分页",
        url: (scaleId) => `${BASE_URI}/scaleSubject/pager/${scaleId}`,
      },
      getScaleSubjectGroupByType: {
        name: "量表题型数量分组",
        url: BASE_URI + "/scaleSubject/getSubjectGroupByType",
      },
      queryScaleConfigInfo: {
        name: "查看量表基本信息",
        url: BASE_URI + "/scale/info/",
      },
      scaleRelateExam: {
        name: "查看关联的考场",
        url: (scaleId) => `${BASE_URI}/scale/scaleRelateExam/${scaleId}`,
      },
      delete: {
        name: "删除量表",
        url: BASE_URI + "/scale/delete",
      },
      scaleList: {
        name: "量表列表",
        url: BASE_URI + "/scaleInfo/getScaleList",
      },
      getScaleProjectName: {
        name: "量表被调用项目名称",
        url: BASE_URI + "/scaleInfo/getScaleProjectName",
      },
      getScaleUserInfo: {
        name: "量表用户测评信息",
        url: BASE_URI + "/scaleInfo/getScaleUserInfo",
      },
      subjectPager: {
        name: "量表用户测评信息",
        url: BASE_URI + "/scaleInfo/subjectPager",
      },
      findSubject: {
        name: "量表用户测评信息",
        url: BASE_URI + "/scaleInfo/findSubject",
      },
      saveSubject: {
        name: "保存题目及选项",
        url: BASE_URI + "/scaleInfo/saveSubject",
      },
      delSubject: {
        name: "删除题目",
        url: BASE_URI + "/scaleInfo/delSubject",
      },
      batchDeleteSubject: {
        name: "量表用户测评信息",
        url: BASE_URI + "/scaleInfo/batchDeleteSubject",
      },
      getWdList: {
        name: "维度列表",
        url: BASE_URI + "/scaleInfo/getWdList",
      },
      getWdInfo: {
        name: "维度信息",
        url: BASE_URI + "/scaleInfo/getWdInfo",
      },
      saveWdInfo: {
        name: "维度信息",
        url: BASE_URI + "/scaleInfo/saveWdInfo",
      },
      delWd: {
        name: "维度信息",
        url: BASE_URI + "/scaleInfo/delWd",
      },
      getSubByWdcode: {
        name: "维度信息",
        url: BASE_URI + "/scaleInfo/getSubByWdcode",
      },
      getScaleProject: {
        name: "维度信息",
        url: BASE_URI + "/scaleInfo/getScaleProject",
      },
      importSubjects: {
        name: "导入量表题目",
        url: {
          import: BASE_URI + "/scaleInfo/importSubjects",
          import2: BASE_URI + "/scaleInfo/importSubjects2",
          exportError: BASE_URI + "/scaleInfo/exportSubjectsError",
        },
      },
      getWdListByScales: {
        name: "根据量表查询维度",
        url: BASE_URI + "/scaleInfo/getWdListByScales",
      },
      getSubjectTypeCount: {
        name: "查询题目类型数量",
        url: BASE_URI + "/scaleInfo/getSubjectTypeCount",
      },
      previewSubject: {
        name: "预览题目",
        url: BASE_URI + "/scaleInfo/previewSubject",
      },
      replaceSubject: {
        name: "替换题目",
        url: BASE_URI + "/scaleInfo/replaceSubject",
      },
      getReplaceSubjectList: {
        name: "获取替换题目列表",
        url: BASE_URI + "/scaleInfo/getReplaceSubjectList",
      },
      confirmReplaceSubject: {
        name: "确认替换题目",
        url: BASE_URI + "/scaleInfo/confirmReplaceSubject",
      },
      addDuplicateSubject: {
        name: "添加重复题干",
        url: BASE_URI + "/scaleInfo/addDuplicateSubject",
      },
      addScaleTk: {
        name: "新增题库量表",
        url: BASE_URI + "/scaleInfo/addScaleTk",
      },
      downloadScaleSubject: {
        name: "下载量表试卷",
        url: BASE_URI + "/scaleInfo/downloadScaleSubject",
      },
      saveSubjectByScaleEnableType: {
        name: "根据量表enableType的值保存题目",
        url: BASE_URI + "/scaleInfo/saveSubjectByScaleEnableType",
      },
      getScaleRanking: {
        name: "查看量表排名",
        url: BASE_URI + "/scaleInfo/getScaleRanking",
      },
      exportRanking: {
        name: "导出量表排名",
        url: BASE_URI + "/scaleInfo/exportScaleRank",
      },
    },
  },
  examApi: {
    resource: false,
    api: {
      getExamPager: {
        name: "分页查询考场",
        url: BASE_URI + "/exam/pager",
      },
      examList: {
        name: "考场列表",
        url: BASE_URI + "/exam/list",
      },
      getExam: {
        name: "根据id查询考场",
        url: BASE_URI + "/exam/info/",
      },
      saveInfoDraft: {
        name: "保存考场信息草稿",
        url: BASE_URI + "/exam/saveInfoDraft",
      },
      saveInfoEdit: {
        name: "修改考场信息-仅暂停的考场可以修改部分字段",
        url: BASE_URI + "/exam/saveInfoEdit",
      },
      submitExam: {
        name: "提交考场草稿",
        url: BASE_URI + "/exam/submitExam",
      },
      deleteExam: {
        name: "删除考场-仅草稿状态可以删除",
        url: BASE_URI + "/exam/delete",
      },
      getScaleRanking: {
        name: "查看统计",
        url: BASE_URI + "/exam/getScaleRanking",
      },
      getUserScaleRankingByCondition: {
        name: "条件查询用户量表排名",
        url: BASE_URI + "/exam/getUserScaleRankingByCondition",
      },
      getExamListByAgentId: {
        name: "根据机构id查询考场",
        url: BASE_URI + "/exam/getExamListByAgentId/"
      },
      bindExam:{
        name:"绑定场次",
        url:BASE_URI+"/exam/bindUserExam"
      },
      startOrStopExam:{
        name:"暂停/启动考场",
        url: (id) => `${BASE_URI}/exam/startOrStopExam/${id}`,
      },
      importResetUser: {
        name: "excel导入重置用户",
        url: BASE_URI + "/exam/importResetUser",
      },
      exportResetUserInfo: {
        name: "导出重置量表用户信息",
        url: BASE_URI + "/exam/exportResetUserInfo",
      },
      resetUserScaleSelection: {
        name: "复选框重置用户量表",
        url: BASE_URI + "/exam/resetUserScaleSelection",
      },
      exportUserExamMajorScore: {
        name: "导出考生专业成绩",
        url: BASE_URI + "/exam/exportUserExamMajorScore"
      },
      viewExamUrl: {
        name: '考场链接',
        url: (id) => `${BASE_URI}/exam/viewExamUrl/${id}`,
      },
      getExamUserPager: {
        name: '获取考场考生分页',
        url: BASE_URI + '/exam/getExamUserPager',
      },
      examUserListExport: {
        name: '考场考生信息导出',
        url: BASE_URI + '/exam/examUserListExport',
      },
      copyExam: {
        name: "复制考场",
        url: BASE_URI + "/exam/copyExam",
      },
      getExamAgentList: {
        name: '查询考场机构列表',
        url: BASE_URI + '/exam/getExamAgentList',
      },
      getExamAgentFinishPager: {
        name: '分页查询考场机构完成率统计',
        url: BASE_URI + '/exam/getExamAgentFinishPager',
      },
    }
  },
  examScaleApi: {
    resource: false,
    api: {
      getScaleOptions: {
        name: "查询考场可选量表列表",
        url: BASE_URI + "/examScale/getScaleOptions",
      },
      getExamScaleList: {
        name: "查询考场量表列表",
        url: BASE_URI + "/examScale/getExamScaleList",
      },
      queryExamScaleConfigInfo: {
        name: "查询考场量表基础信息",
        url: BASE_URI + "/examScale/info/",
      },
      saveExamScaleBaseInfoDraft: {
        name: "保存考场量表基础信息草稿",
        url: BASE_URI + "/examScale/saveBaseInfoDraft",
      },
      saveExamScaleSubjectDraft: {
        name: "保存考场量表题目信息草稿",
        url: BASE_URI + "/examScale/saveSubjectDraft",
      },
      saveExamScaleSubjectConfigDraft: {
        name: "保存考场量表试卷配置草稿",
        url: BASE_URI + "/examScale/saveSubjectConfigDraft",
      },
      submitExamScale: {
        name: "提交考场量表草稿",
        url: BASE_URI + "/examScale/submitExamScale",
      },
      exportScaleRanking: {
        name: "导出统计",
        url: BASE_URI + "/examScale/exportScaleRanking",
      },
    }
  },
  examScaleSubjectApi: {
    resource: false,
    api: {
      getExamScaleSubjectPager: {
        name: "分页查询考场量表题库",
        url: BASE_URI + "/examScaleSubject/pager",
      },
      getExamScaleSubject: {
        name: "根据id查询考场量表题目",
        url: BASE_URI + "/examScaleSubject/info/",
      },
      updateExamScaleSubject: {
        name: "修改考场量表题目",
        url: BASE_URI + "/examScaleSubject/update",
      },
      deleteExamScaleSubject: {
        name: "删除考场量表题目",
        url: BASE_URI + "/examScaleSubject/delete",
      },
      batchDeleteExamScaleSubject: {
        name: "批量删除考场量表题目",
        url: BASE_URI + "/examScaleSubject/batchDelete",
      },
      getExamScaleSubjectGroupByType: {
        name: "量表题型数量分组",
        url: BASE_URI + "/examScaleSubject/getSubjectGroupByType",
      },
      changeSort: {
        name: "修改排序",
        url: (examScaleId, id) => `${BASE_URI}/examScaleSubject/changeSort/${examScaleId}/${id}`,
      },
      getAddSubjectPager: {
        name: "分页查询量表可添加题目",
        url: `${BASE_URI}/examScaleSubject/getAddSubjectPager`,
      },
      findSubjectChooseGroup: {
        name: "获取题目list根据题型分组",
        url: `${BASE_URI}/examScaleSubject/findSubjectChooseGroup`,
      },
      choseSubjectByType: {
        name: "根据题型抽题",
        url: `${BASE_URI}/examScaleSubject/choseSubjectByType`,
      },
      createBySubjectIdList: {
        name: "根据量表题库id列表批量创建考场量表题目",
        url: (examScaleId) => `${BASE_URI}/examScaleSubject/createBySubjectIdList/${examScaleId}`,
      },
      delBySubjectIdList: {
        name: "根据量表题库id列表批量删除考场量表题目",
        url: (examScaleId) => `${BASE_URI}/examScaleSubject/delBySubjectIdList/${examScaleId}`,
      },
    }
  },
  subjectList: {
    name: "题目列表",
    resource: true,
    api: {
      pager: {
        name: "获取题库分页",
        url: BASE_URI + "/subject/pager",
      },
      getSubject: {
        name: "根据id查询题目",
        url: BASE_URI + "/subject/info/",
      },
      batchDelete: {
        name: "批量删除题目",
        url: BASE_URI + "/subject/batchDelete",
      },
      getWdList: {
        name: "获取维度列表",
        url: BASE_URI + "/subject/getWdList",
      },
      create: {
        name: "创建题目",
        url: BASE_URI + "/subject/create",
      },
      update: {
        name: "修改题目",
        url: BASE_URI + "/subject/update",
      },
      importSubjects: {
        name: "导入题目",
        url: BASE_URI + "/subject/importSubjects",
      },
      exportSubjectsError: {
        name: "导题异常记录导出",
        url: BASE_URI + "/subject/exportSubjectsError",
      },
    }
  },
  examStatistics: {
    name: "考场统计",
    resource: true,
    api: {
      data: {
        name: "总览",
        url: BASE_URI + "/examStatistics/data",
      },
      pager: {
        name: "分页考场机构数据",
        url: BASE_URI + "/examStatistics/pager",
      },
      getAllAgent: {
        name: "获取所有机构（包含自己和所有子机构）",
        url: BASE_URI + "/examStatistics/getAllAgent",
      },
      exportPager: {
        name: "导出统计详情",
        url: BASE_URI + "/examStatistics/exportPager",
      },
    }
  },
  projectStatistics: {
    name: "项目统计",
    resource: true,
    api: {
      profile: {
        name: "项目概况",
        url: BASE_URI + "/projectStatistics/profile"
      },
      detail: {
        name: "项目详细统计",
        url: {
          pager: BASE_URI + "/projectStatistics/detailPager",
          searchPager: BASE_URI + "/projectStatistics/detailSearchPager",
          projectUserPager: BASE_URI + "/projectStatistics/projectUserPager",
          downloadProjectDetail:
            BASE_URI + "/projectStatistics/downloadProjectDetail"
        }
      },
      getAgentIncomTree: {
        name: "收益统计",
        url: BASE_URI + "/projectStatistics/getAgentIncomTree"
      },
      getAgentIncomTreePager: {
        name: "收益统计分页",
        url: BASE_URI + "/projectStatistics/getAgentIncomTreePager"
      },
      downloadAgentIncomeTree: {
        name: "项目概况",
        url: BASE_URI + "/projectStatistics/downloadAgentIncomeTree"
      }
    }
  },
  importUserAccount: {
    name: "导入生成测评账号",
    resource: true,
    api: {
      userPager: {
        name: "测评账号分页列表",
        url: {
          pager: BASE_URI + "/userAccount/userPager",
          searchPager: BASE_URI + "/userAccount/searchUserPager"
        }
      },
      produce: {
        name: "生成测评账号",
        url: {
          getExamList: BASE_URI + "/userAccount/getExamList",
          accountImport: BASE_URI + "/userAccount/accountImport",
          produceUserAccount: BASE_URI + "/userAccount/createAccount",
          exportUserAccount: BASE_URI + "/userAccount/exportAccount",
          exportAccountError: BASE_URI + "/userAccount/exportAccountError",
          doCreateAccount: BASE_URI + "/userAccount/doCreateAccount"
        }
      }
    }
  },
  orderInfo: {
    name: "订单列表",
    resource: true,
    api: {
      pager: {
        name: "订单分页列表",
        url: BASE_URI + "/orderInfo/pager"
      },
      searchPager: {
        name: "订单分页列表搜索功能",
        url: BASE_URI + "/orderInfo/searchPager"
      },
      earnings: {
        name: "收益总览",
        url: BASE_URI + "/projectStatistics/earnings"
      },
      downloadOrder: {
        name: "导出订单",
        url: BASE_URI + "/orderInfo/downloadOrder"
      }
    }
  },
  signUp: {
    name: "报名管理",
    resource: true,
    api: {
      pager: {
        name: "报名管理分页查询",
        url: BASE_URI + "/application/page"
      },
      insert: {
        name: "代理商端新增报名用户",
        url: BASE_URI + "/application/insert"
      },
      update: {
        name: "代理商端修改报名详情中的用户",
        url: BASE_URI + "/application/updateUser"
      },
      import: {
        name: "代理商端报名导入",
        url: BASE_URI + "/application/import"
      },
      export: {
        name: "代理商端报名导入",
        url: BASE_URI + "/application/export"
      },
      detail: {
        name: "报名管理详情查询",
        url: BASE_URI + "/application/detail"
      },
      delete: {
        name: "代理商端报名详情逻辑删除",
        url: BASE_URI + "/application/logicDelete"
      }
    }
  },
};

/**
 * 获取资源树配置，用于权限管理
 */
export function getResourceConfigs() {
  let result = [];

  Object.keys(apiConfig).forEach(function(key) {
    let itemVal = apiConfig[key];
    if (itemVal && itemVal.resource == true) {
      let res = { operatorCode: key, operatorName: itemVal.name };
      let operators = [];
      if (itemVal.api && Object.keys(itemVal.api).length > 0) {
        Object.keys(itemVal.api).forEach(function(opKey) {
          let operMap = itemVal.api[opKey];
          if (operMap) {
            var authUrls = getAuthUrls(operMap.url);
            let operator = {
              operatorCode: opKey,
              operatorName: operMap.name,
              authUrls: authUrls
            };
            operators.push(operator);
          }
        });
      }
      res.operators = operators;
      result.push(res);
    }
  });

  return result;
}

function getAuthUrls(url) {
  if (url && typeof url == "string") {
    return [url];
  } else if (url && Object.keys(url).length > 0) {
    let urls = [];
    Object.keys(url).forEach(function(key) {
      var val = url[key];
      if (val) {
        urls.push(val);
      }
    });
    return urls;
  }
  return null;
}
